__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "crew-scheduling-ui";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@ant-design/icons", "5.3.0", () => (Promise.all([__webpack_require__.e(760), __webpack_require__.e(304), __webpack_require__.e(816), __webpack_require__.e(256)]).then(() => (() => (__webpack_require__(13304))))));
			register("antd", "5.14.2", () => (Promise.all([__webpack_require__.e(760), __webpack_require__.e(24), __webpack_require__.e(952), __webpack_require__.e(816), __webpack_require__.e(48)]).then(() => (() => (__webpack_require__(39024))))));
			register("react-dom", "18.2.0", () => (Promise.all([__webpack_require__.e(292), __webpack_require__.e(816)]).then(() => (() => (__webpack_require__(51292))))));
			register("react", "18.2.0", () => (__webpack_require__.e(60).then(() => (() => (__webpack_require__(69060))))));
			initExternal(26680);
			initExternal(80784);
			initExternal(51696);
			initExternal(97288);
			initExternal(94672);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};